import { ActionContext, ActionTree } from "vuex";
import {
  IAssessmentState,
  IAssessmentSubject,
} from "@/store/modules/assessment/types";
import { IAnswer, RootState } from "@/store/types";
import { ApiCaller } from "@/ApiCaller";

type AssessmentActionContext = ActionContext<IAssessmentState, RootState>;
type AssessmentActionTree = ActionTree<IAssessmentState, RootState>;

export const actions: AssessmentActionTree = {
  async takeSection(
    context: AssessmentActionContext,
    params: any
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/assessment/take-section/${params.subject}/${params.testNumber}/${params.number}`
    );
    context.commit("setSection", content.data);
  },

  async fetchSections(context: AssessmentActionContext): Promise<any> {
    const sections: any = await ApiCaller.getInstance().get(
      `/homeroom/sections`
    );

    context.commit("setSections", sections);
  },

  async fetchAnsweredQuestions(
    context: AssessmentActionContext,
    params: any
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/assessment/review-questions/${params.subject}/${params.testNumber}`
    );
    context.commit("setAnsweredQuestions", content.data);
  },

  async fetchAssessmentFeedback(
    context: AssessmentActionContext,
    params: any
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/assessment/feedback/${params.subject}/${params.testNumber}`
    );
    context.commit("setAssessmentFeedback", content.data);
  },

  async fetchQuestionLessons(
    context: AssessmentActionContext,
    question_id: number
  ): Promise<any> {
    const lessons = await ApiCaller.getInstance().get(
      `/assessment/question-lessons/${question_id}`
    );
    context.commit("setQuestionLessons", lessons.data);
  },

  async reviewQuestion(
    context: AssessmentActionContext,
    payload: {}
  ): Promise<any> {
    await ApiCaller.getInstance().post("/assessment/question-viewed", payload);
  },

  async feedbackQuestion(
    context: AssessmentActionContext,
    payload: {}
  ): Promise<any> {
    await ApiCaller.getInstance().post(
      "/assessment/question-feedback",
      payload
    );
  },

  async saveAnswer(
    context: AssessmentActionContext,
    payload: IAnswer
  ): Promise<any> {
    if (Array.isArray(payload.answer_obj) && payload.answer_obj) {
      const answerObj = payload.answer_obj.reduce(
        (acc: any, cv: number, index: any) => ({ ...acc, [index + 1]: cv }),
        {}
      );

      payload.answer_obj = answerObj;
    }

    await ApiCaller.getInstance().postWithoutRetry(
      "/assessment/save-answer",
      payload
    );
  },

  async saveAnswers(
    context: AssessmentActionContext,
    payload: IAnswer
  ): Promise<any> {
    await ApiCaller.getInstance().post("/assessment/save-answers", payload);
  },

  async finishSection(
    context: AssessmentActionContext,
    payload: {
      usectionId: number;
      timeRemain: number;
    }
  ): Promise<any> {
    await ApiCaller.getInstance().post("/assessment/finish-section", {
      usection_id: payload.usectionId,
      time_remain: payload.timeRemain,
    });
  },

  async handleQuestionFeedback(
    context: AssessmentActionContext,
    payload: {
      uquestion_id: number;
      feedback: string;
    }
  ): Promise<any> {
    await ApiCaller.getInstance().post("/assessment/question-feedback", {
      uquestion_id: payload.uquestion_id,
      feedback: payload.feedback,
    });
  },

  async takePracticeSection(
    context: AssessmentActionContext,
    params: any
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/practice/section/${params.subject}`
    );
    context.commit("setSection", content.data);
  },
};
